import { getAuthenticatedUser } from '@edx/frontend-platform/auth';

import type { CourseAboutDataPartial } from '../types';
import { useEnrollmentActions, useEnrollmentStatus } from './hooks';

export const CourseIntro = ({ courseAboutData }: { courseAboutData: CourseAboutDataPartial }) => {
  const authenticatedUser = getAuthenticatedUser();

  const {
    id: courseId,
    displayOrgWithDefault: courseOrg,
    name: courseName,
    shortDescription,
    ecommerceCheckoutLink,
  } = courseAboutData;

  const {
    enrollmentError,
    isEnrollmentPending,
    handleChangeEnrollment,
    handleEcommerceCheckout,
  } = useEnrollmentActions({ courseId, ecommerceCheckoutLink });

  const { renderStatusContent } = useEnrollmentStatus({
    courseAboutData,
    enrollmentError,
    authenticatedUser,
    isEnrollmentPending,
    handleChangeEnrollment,
    handleEcommerceCheckout,
  });

  return (
    <div className="course-about-intro">
      {courseOrg && <p className="course-about-intro__org">{courseOrg}</p>}
      <h1 className="course-about-intro__title">{courseName}</h1>
      {shortDescription && (
        <p className="course-about-intro__description">
          {shortDescription}
        </p>
      )}
      <div className="course-about-intro__cta">
        {renderStatusContent()}
      </div>
    </div>
  );
};
